import styled from "styled-components";
import { InfoGameCardProps } from "./InfoGameCard.types";
import { typographyMixin } from "../../../typography";

type props = Pick<InfoGameCardProps, "theme">;

export const StyledInfoGameCard = styled.div.attrs({
  className: "infogamecard",
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 1fr;
  width: 1fr;
  border-radius: 5px;
  background: #fff;
  box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.25);
  ${typographyMixin}
`;

export const ContentContainer = styled.div.attrs({
  className: "infogamecard-contentcontainer",
})`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex: 3;
`;

export const Date = styled.div.attrs({
  className: "infogamecard-date",
})<props>`
  height: 38px;
  max-height: 38px;
  width: 100%;
  background-color: ${(props) => props.theme.secondaryColor};
  color: ${(props) => props.theme.textOnSecondaryColor};
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  justify-content: flex-start;
  padding: 0.5rem 0rem 0.5rem 1.5rem;
  align-items: center;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  flex: 1;
`;

export const Location = styled.div.attrs({
  className: "infogamecard-location",
})`
  padding: 0.5rem 0;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  flex: 1;
`;

export const Opponent = styled.div.attrs({
  className: "infogamecard-opponent",
})`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OpponentLogo = styled.img.attrs({
  className: "infogamecard-img",
})`
  padding: 0 0.5rem;
  max-width: 96px;
  max-height: 96px;
  object-fit: contain;
`;

export const OpponentTitle = styled.div.attrs({
  className: "infogamecard-opponenttitle",
})`
  padding: 0 0.5rem;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;
  flex-basis: 50%;
`;

export const ResultOrTime = styled.div.attrs({
  className: "infogamecard-resultortime",
})`
  text-align: center;
  font-size: 2rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  padding-bottom: 0.5rem;
`;
